import { useCallback } from 'react'
import { get } from 'aws-amplify/api'
import { useAppContext, actionTypes } from '../context/AppContext'

export function useBugfixList() {
  const { state, dispatch } = useAppContext()
  
  const fetchBugfixList = useCallback(async () => {
    dispatch({ type: actionTypes.FETCH_BUGFIX_LIST_START })
    
    try {
      const { response } = get({
        apiName: 'FetchBugfixList',
        path: 'bugfixes'
      })
      const res = await response
      const data = await res.body.json()
      dispatch({
        type: actionTypes.FETCH_BUGFIX_LIST_SUCCESS,
        payload: data
      })
    } catch (error) {
      console.error(error)
      dispatch({ type: actionTypes.FETCH_BUGFIX_LIST_ERROR })
    }
  }, [dispatch])
  
  const toggleBug = useCallback((project, bug) => {
    dispatch({
      type: actionTypes.TOGGLE_BUG,
      project,
      bug
    })
  }, [dispatch])
  
  return {
    bugfixList: state.bugfixList,
    fetchBugfixListInProgress: state.fetchBugfixListInProgress,
    fetchBugfixListHasErrored: state.fetchBugfixListHasErrored,
    fetchBugfixList,
    toggleBug
  }
}
